import type { StateCreator } from 'zustand';
import type { Employee } from '../types';
import { employeesApi } from '../services/employeesApi';

export interface EmployeesSlice {
  employees: Employee[];
  employeesLoading: boolean;
  employeesError: boolean;
  fetchEmployees: () => Promise<void>;
  createEmployee: (data: Partial<Employee>) => Promise<void>;
  updateEmployee: (id: number, data: Partial<Employee>) => Promise<void>;
  removeEmployee: (id: number) => Promise<void>;
}

export const createEmployeesSlice: StateCreator<EmployeesSlice> = (set, get) => ({
  employees: [],
  employeesLoading: false,
  employeesError: false,

  fetchEmployees: async () => {
    set({ employeesLoading: true, employeesError: false });
    try {
      const data = await employeesApi.list();
      set({ employees: data, employeesLoading: false });
    } catch {
      // 403 für Nicht-Admins ist erwartbar – als "error" markieren, Liste leer lassen
      set({ employeesLoading: false, employeesError: true });
    }
  },

  createEmployee: async (data) => {
    await employeesApi.create(data);
    await get().fetchEmployees();
  },

  updateEmployee: async (id, data) => {
    await employeesApi.update(id, data);
    await get().fetchEmployees();
  },

  removeEmployee: async (id) => {
    await employeesApi.remove(id);
    await get().fetchEmployees();
  },
});
